module.exports = __webpack_public_path__ + "img/loader.7c3e8212.svg";